import React from 'react'
import EmptyPage from '../../SubComp/EmptyPage/EmptyPage'

const EmptyMessage = () => {
  return (
    <div>
        <EmptyPage title='Messages' text='You don’t have any messages.'/>
    </div>
  )
}

export default EmptyMessage;